<template>
  <scoped>
    <div @keyup.enter="emits('update')">
      <button @click="emits('update')">
        <img
          alt="Search"
          src="../images/search_icon.png"
        >
      </button>
      <input
        v-model="value"
        type="text"
      >
    </div>
  </scoped>
</template>

<script setup lang="ts">
  const emits = defineEmits(["update"])
  const value = defineModel("value", {
    default: null,
    required: true,
    type: String
  })
</script>

<style scoped>
  div {
    background-color: var(--color-white);
    border-color: var(--theme-color-primary);
    border-radius: var(--border-radius-small);
    border-style: solid;
    border-width: var(--border-width-light);
    display: inline-block;
    margin: 0.5em;
    white-space: pre;

    &:hover, &:focus-within {
      border-color: var(--color-grey);

      > button {
        background-color: var(--color-grey);
      }
    }

    > button {
      background-color: var(--theme-color-primary);
      border: none;
      cursor: pointer;
      padding: 0.5em;

      > img {
        height: 1em;
        vertical-align: middle;
      }
    }

    > input[type = text] {
      border: none;
      padding: 0.5em;
    }
  }
</style>
